import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["popover"]

  toggle(event) {
    event.stopPropagation()
    this.popoverTarget.classList.toggle("hidden")
  }

  hide(event) {
    if (!this.element.contains(event.target)) {
      this.popoverTarget.classList.add("hidden")
    }
  }

  connect() {
    this.boundHide = this.hide.bind(this)
    document.addEventListener("click", this.boundHide)
  }

  disconnect() {
    document.removeEventListener("click", this.boundHide)
  }
}
